import React from 'react';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE, FEDERAL_TESTIMONY_SECTION_ID, FEDERAL_TESTIMONY_SECTION_TEST_ID, FEDERAL_TESTIMONY_TITLE_INPUT_TEST_ID, FEDERAL_TESTIMONY_WHO_TESTIFIED_FIELD_INPUT_TEST_ID, TITLE, WHO_TESTIFIED } from './constants';
export var FederaltestimonyCitingSection = function FederaltestimonyCitingSection() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: FEDERAL_TESTIMONY_SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(FEDERAL_TESTIMONY_SECTION_ID, "-label"),
    dataTestId: FEDERAL_TESTIMONY_SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    name: "testimony.title",
    labelText: TITLE,
    "data-test": FEDERAL_TESTIMONY_TITLE_INPUT_TEST_ID,
    isRecommended: false
  }), /*#__PURE__*/React.createElement(Input, {
    name: "testimony.who",
    labelText: WHO_TESTIFIED,
    "data-test": FEDERAL_TESTIMONY_WHO_TESTIFIED_FIELD_INPUT_TEST_ID,
    isRecommended: false
  }));
};